import { SelectOption } from 'features/app/components/SelectInput';

const mapSelectOption = (selectOption: SelectOption) => {
  return selectOption.value;
};

const mapField = (field: SelectOption | SelectOption[]) => {
  if (Array.isArray(field)) {
    return field.map(mapSelectOption);
  }

  return mapSelectOption(field);
};

/**
 * Transforms SelectOption to SelectOption.value in selected fields. Supports both SelectOption and SelectOption[].
 * @param fields fields to transform
 * @param selectOutput  form state
 * @returns transformed form state
 */
export function mapSelectOutput<T>(fields: (keyof T)[], selectOutput: T): T {
  const mappedFields = fields.reduce(
    (acc, field) => ({ ...acc, [field]: mapField(selectOutput[field] as unknown as SelectOption) }),
    {}
  );

  return {
    ...selectOutput,
    ...mappedFields,
  };
}
